
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Link from "@/components/Link.vue";
import P5 from "p5";
import BookMenu from "@/components/BookMenu.vue";
import ColorScaleCompService from '@/services/ColorScaleComp.service';
import ColorScalesHeader from "@/components/ColorScalesHeader.vue";
import BackButton from "@/components/BackButton.vue";

const namespace = "BookModule";

@Component({
  components: {
    Link,
    BookMenu,
    ColorScalesHeader,
    BackButton
  },
})

export default class ArticleColorSpaces extends Vue{
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
    const script = function (p5: any){
      let att:number, dec:number, sus:number, rel:number, A:number, total:number;
      const susLength = 2;
      let ball:any;
      const colors = ["#cf4c4c", "#846d21", "#248c46", "#f34b88", "#c66735", "#5f8d35", "#19a085"];
      let selectedColor = "#ffffff";
      let clickTime = 0;
      let pressed = false;
      let attackSlider:any;
      let decaySlider:any;
      let sustainSlider:any;
      let releaseSlider:any;
      
      function drawGraphic(x:any, y:any, gWidth:any, gHeight:any){
        p5.push();
        p5.fill(200);
        p5.rect(x, y, gWidth, gHeight);
        const mAtt = p5.map(att, 0, total, 0, gWidth);
        const mDec = p5.map(dec, 0, total, 0, gWidth);
        const mSusLength = p5.map(susLength, 0, total, 0, gWidth);
        const mRel = p5.map(rel, 0, total, 0, gWidth);
        const mSus = p5.map(sus, 0, A, 0, gHeight);
        //
        p5.fill(150)
        p5.rect(x, y, mAtt, 30);
        p5.rect(x+mAtt, y, mDec, 30);
        p5.rect(x+mAtt+mDec, y, mSusLength, 30);
        p5.rect(x+mAtt+mDec+mSusLength, y, mRel, 30);
        p5.fill(0);
        //p5.line A
        p5.translate(x,y);
        p5.line(0, 0, mAtt, gHeight);
        //p5.line D
        p5.line(mAtt, gHeight, mAtt+mDec, mSus);
        //p5.line S
        p5.line(mAtt+mDec, mSus, mAtt+mDec+mSusLength, mSus);
        //p5.line R
        p5.line(mAtt+mDec+mSusLength, mSus, mAtt+mDec+mSusLength+mRel, 0);
        
        const t = (p5.millis()-clickTime)/1000;
        
        let size = 0;
        let posX = 0;
        let posY = 0;
        if(pressed){
          if(t<att){
            posX = (mAtt/att)*t;
            posY = (gHeight/att)*t;
          }else if(t>att && t<att+dec){
            posX = (mDec/dec)*t;
            posY = gHeight - ((gHeight-mSus)/dec)*(t-att);
          }else{
            //posX = mAtt+mDec+mSusLength*((t-att-dec)/susLength);
            const v = t-att-dec;
            posX = mAtt+mDec+mSusLength*v/susLength;
            posX = posX>mAtt+mDec+mSusLength?mAtt+mDec+mSusLength:posX;
            posY = mSus;
          }
        }else{
          posX = mAtt+mDec+mSusLength + mRel/rel*t;
          posY = mSus - (mSus/rel)*t;
        }
        size*=2;
        p5.fill(selectedColor);
        p5.ellipse(posX, posY, 20, 20); 
        p5.pop();
      }
      function drawControls(x:any, y:any, gWidth:any, gHeight:any){
        p5.rect(x, y, gWidth, gHeight);
        
        for(let i=0; i<7; i++){
          p5.fill(colors[i]);
          p5.rect(x+i*gWidth/7, y, gWidth/7, gHeight);
        }
      }
      class Ball{
        x: number;
        y: number;
        constructor(){
          this.x = p5.width/2;
          this.y = p5.height/1.4;
        }
        draw(){
          const t = (p5.millis()-clickTime)/1000;
          p5.fill(selectedColor);
          let size = 0;
          if(pressed){
            if(t<att){
              size = (A/att)*t;
            }else if(t>att && t<att+dec){
              size = (A-(t-att)*(A-sus)/dec);
            }else{
              size = sus; 
            }
          }else{
            size = sus - t*sus/rel; 
            if(size<0){
              size=0;
            }
          }
          size*=2;
          p5.ellipse(this.x, this.y, size, size); 
        }
      }
      p5.mousePressed = () => {
        for(let i=0; i<7; i++){
          if(p5.mouseX>i*p5.width/7 && p5.mouseX<(i+1)*p5.width/7 && p5.mouseY<p5.height && p5.mouseY>p5.height-50){
            selectedColor = colors[i];
            clickTime = p5.millis();
            pressed = true;
          }
        }
      }
      p5.mouseReleased = () => {
        if(pressed){
          pressed = false;
          clickTime = p5.millis();
        }
      }
      p5.setup = (_:any) => {   
        const canvas = p5.createCanvas(600, 600);
        canvas.parent("p5Canvas");  
        dec = 0.5;
        sus = 50;
        rel = 1;
        A = 100;
        ball = new Ball(); 
        attackSlider = p5.createSlider(0, 5, 0.5, 0.1);
        attackSlider.parent("attackSlider"); 
        decaySlider = p5.createSlider(0, 5, 0.5, 0.1);
        decaySlider.parent("decaySlider"); 
        sustainSlider = p5.createSlider(0, 100, 50, 1);
        sustainSlider.parent("sustainSlider"); 
        releaseSlider = p5.createSlider(0, 5, 0.5, 0.1);
        releaseSlider.parent("releaseSlider"); 
      }    
      p5.draw = (_:any) => {    
        p5.background(220);
        p5.fill(0);
        p5.rect(0,0,600,p5.height*2/3-50);
        att=attackSlider.value();
        dec=decaySlider.value();
        sus=sustainSlider.value();
        rel=releaseSlider.value();
        total = att+dec+2+rel;
        p5.push();
        p5.translate(0, p5.height);
        p5.scale(1, -1);
        
        drawGraphic(0, 50, p5.width, p5.height/3);
        drawControls(0, 0, p5.width, 50);
        ball.draw();
        p5.pop();
        p5.textAlign(p5.LEFT);
        p5.fill(255);
        p5.text("Press and hold a color. Then release.", 10, 340);
        //Lletres
        p5.fill(0);
        const mAtt = p5.map(att, 0, total, 0, p5.width);
        const mDec = p5.map(dec, 0, total, 0, p5.width);
        const mSusLength = p5.map(susLength, 0, total, 0, p5.width);
        const mRel = p5.map(rel, 0, total, 0, p5.width);
        const mSus = p5.map(sus, 0, A, 0, p5.height/3);
        p5.textAlign(p5.CENTER);
        p5.text("A", mAtt/2, p5.height-60);
        p5.text("D", (2*mAtt+mDec)/2, p5.height-60);
        p5.text("S", (2*mAtt+2*mDec+mSusLength)/2, p5.height-60);
        p5.text("R", (2*mAtt+2*mDec+2*mSusLength+mRel)/2, p5.height-60);
      }  
    }
    const myP5 = new P5(script);
  }

};
